// extracted by mini-css-extract-plugin
export default {"error":"peacegame_Error_error"};